<template>
  <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <div class="flex my-4 flex-col text-right gap-4 items-center justify-center">
      <p class="font-semibold px-8 text-center">
        Confirm you want to send a Handoff Receipt Request To:
      </p>
      <!-- <pre>
          {{ processObj.orgReceiver }}
        </pre
      > -->
      <div class="flex justify-between w-100">
        <div>
          <p class="text-lightGrey">3PL Terminal</p>
          <p>
            {{ processObj.orgReceiver ? processObj.orgReceiver.companyname : "N/A" }}
          </p>
        </div>
        <div class="w-32">
          <p class="text-lightGrey">Name</p>
          <p>
            {{ processObj.userObj ? processObj.userObj.firstname : "N/A" }}
            {{ processObj.userObj ? processObj.userObj.lastname : "N/A" }}
          </p>
        </div>
      </div>
      <div class="flex justify-between w-100">
        <div>
          <p class="text-lightGrey">Phone Number</p>
          <p>{{ processObj.userObj ? processObj.userObj.mobile_no : "N/A" }}</p>
        </div>
        <div class="w-32">
          <p class="text-lightGrey">Address</p>
          <p>
            {{ processObj.locationObj.address ? processObj.locationObj.address : "N/A" }}
          </p>
        </div>
      </div>
      <div class="flex justify-between w-100">
        <div>
          <p class="text-lightGrey">State</p>
          <p>
            {{ processObj.locationObj ? processObj.locationObj.address : "N/A" }}
          </p>
        </div>
        <div class="w-32">
          <p class="text-lightGrey">Email</p>
          <p>{{ processObj.userObj ? processObj.userObj.email : "N/A" }}</p>
        </div>
      </div>
      <div class="flex justify-between w-100">
        <div>
          <p class="text-lightGrey">Delivery Status</p>
          <p class="text-green">{{ this.processObj.reason }}</p>
        </div>
        <div class="w-32">
          <p class="text-lightGrey">Receipt code</p>
          <p>*******</p>
        </div>
      </div>

      <div class="button-wrapper">
        <div>
          <base-button text="Confirm" :loading="loading" @click="sendProcess()" />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  components: {},
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    dispatch: {
      type: Object,
      required: true,
    },
    processObj: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showRequestSentModal: false,
      loading: false,
    };
  },
  methods: {
    async sendProcess() {
      let user = this.$store.state.authentication.user;
      let sender = {
        firstname: user.firstname,
        lastname: user.lastname,
        email: user.email,
        mobile_no: user.mobile_no,
      };

      let postMessage = {
        app: "muleex",
        event: "process:handoff",
        message: {
          module: "dispatch",
          moduleId: this.dispatch.id,
          origin: {
            userId: this.processObj.fromUserId,
            orgId: this.processObj.fromOrgid,
            sender,
          },
          destination: {
            userId: this.processObj.toUserId,
            orgId: this.processObj.toOrgId,
          },
          orgReceiver: this.processObj.orgReceiver,
          dispatch: {
            dispatchId: this.processObj.dispatch.dispatchReference,
            consolidationId: this.processObj.dispatch?.consolidation
              ?.consolidationReference,
            shippingService: this.processObj.dispatch?.shippingservice?.orgName,
            forwarding3pl: {
              companyname: this.$store.state.authentication.organizationDetails
                .companyname,
              mobile_no: this.$store.state.authentication.organizationDetails.mobile_no,
            },
            receiver: {
              name:
                this.processObj.userObj.firstname +
                " " +
                this.processObj.userObj.lastname,
              mobile_no: this.processObj.userObj.mobile_no,
              address: this.processObj.locationObj.address,
            },
          },
          user: this.processObj.userObj,
          location: this.processObj.locationObj,
          reason: this.processObj.reason
        },
      };
      this.$socket.emit("makeMessage", postMessage);

      this.$emit("show-request-sent");
      this.closeModal();
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}

p {
  text-align: left;
}
</style>
